import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiRoutes} from '../../config/api-routes';
import {Observable, of} from 'rxjs';
import { UpdatePassword } from '../shared/model/update-password';

@Injectable()
export class SetPasswordService {
  constructor(private httpClient: HttpClient, private apiRoutes: ApiRoutes) {}

  public savePassword(updatePassword: UpdatePassword): Observable<any> {
    return this.httpClient.post(this.apiRoutes.CONFIRM_FORGOT_PASSWORD, updatePassword);
  }
}

